export const questions: Array<any> = [
  {
    _id: '001',
    res_question:
      "Hi! My name is Eva. I'll find you a sweet deal on energy in seconds. Enter your name to find out!",
    serialNo: 1,
    service: 'Both',
    hg_res_rules: [],
  },
  {
    _id: '002',
    res_question: 'Nice to meet you [first name]! What brings you here today? ',
    add_address:
      'Hi [first name]! I appreciate you wanting to add another address. So that I can best serve you,  I will be asking the same questions since each premise and its use is different. Tell me, what brings you here today? ',
    serialNo: 2,
    service: 'Both',
    hg_res_rules: [
      {
        res_question_id: '001',
        parameter: 'first_name',
      },
    ],
    chkboxtype: '',
  },
  {
    _id: '003',
    res_question: 'Are you currently on contract?',
    serialNo: 3,
    service: 'Switching Providers',
    chkboxtype: '',
    hg_res_rules: [
      {
        res_question_id: '003',
        parameter: 14,
      },
    ],
    tip:
      "It appears you're too far out from your current contract's expiration date. To avoid paying any penalties or early termination fees with your current retail energy provider, I suggest you come back to our website when you are 14 days away from your contract's expiration date. Come back though...I look forward to seeing you in a few days!",
  },
  {
    _id: '004',
    res_question: 'How soon are you wanting to switch energy providers? ',
    serialNo: 4,
    service: 'Switching Providers',
    chkboxtype: 'tap to see what fee may apply',
    hg_res_rules: [
      {
        res_question_id: '008',
        parameter: 'Standard Switch',
      },
    ],
    tip: '',
  },
  {
    _id: '005',
    res_question: 'When would you like to have your energy service switched? ',
    serialNo: 5,
    service: 'Switching Providers',
    hg_res_rules: [],
  },
  // {
  //     '_id': '006',
  //     'res_question': 'Please confirm the date below is correct',
  //     'serialNo': 6,
  //     'service': 'Switching Providers'
  // },
  {
    _id: '007',
    res_question: 'When will you be needing energy service turned ON?',
    serialNo: 7,
    service: 'New Service',
    tip:
      'There will be a small fee for getting power turned on any earlier than the first date offered in the calendar above. If you need service immediately, please contact your selected energy provider after completing your enrollment.',
    tip1:
      'If you need service immediately, please contact your selected energy provider after completing your enrollment.',
  },
  {
    _id: '008',
    res_question: "Great, we can definitely help! What's your address?",
    serialNo: 8,
    service: 'Both',
  },
  {
    _id: '009',
    res_question: 'Which best describes your home type? ',
    serialNo: 9,
    service: 'Both',
    chkboxtype: '',
  },
  {
    _id: '0010',
    res_question: 'Do you rent or own it? ',
    serialNo: 10,
    service: 'Both',
    chkboxtype: '',
  },
  {
    _id: '0011',
    res_question: 'How big is your home? ',
    serialNo: 11,
    service: 'Both',
    tip:
      "Did you know that 1 sqft = approximately 1 kWh? It's okay if you don't know the exact square footage.  Just give me your best guess.",
  },
  {
    _id: '0012',
    res_question: 'What is the floorplan of your home? ',
    serialNo: 12,
    service: 'Both',
  },
  {
    _id: '0013',
    res_question: 'When was your home built? ',
    serialNo: 13,
    service: 'Both',
    tip: "It's okay if you don't remember.  Just give me your best guess.",
  },
  {
    _id: '0014',
    res_question: 'How many people occupy your home most of the time? ',
    res_question_ns: 'How many people will occupy your home most of the time? ',
    serialNo: 14,
    service: 'Both',
    renewal_question:
      "Hi [first name]! I'm so glad you have decided to come back and am happy to serve you again!  I will be asking a few clarifying questions to see if anything has changed since the last time. How many people now occupy your home most of the time?",
    renewal_tip: "Hope you're enjoying the added company :) ",
  },
  {
    _id: '0015',
    res_question: 'How do you heat your home? ',
    serialNo: 15,
    service: 'Both',
    tip:
      'If your home is heated by electricity, it will consume far more power than a home heated by natural gas.',
    chkboxtype: '',
  },
  {
    _id: '0016',
    res_question: 'What is it primarily used for?',
    res_question_ns: 'What will it primarily be used for?',
    serialNo: 16,
    service: 'Both',
    tip:
      "Having a home-based business may beat going to an office everyday, but there's a good chance you're using more electricity. Having a computer running along with other office electronics, will increase your energy spend. It also means more lights are on and that you're heating or cooling your home longer and for more hours of the day.",
    chkboxtype: 'Tap all that apply',
    renewal_question: 'What is it primarily used for?',
  },
  {
    _id: '0017',
    res_question: 'How many workday hours are spent at your home? ',
    serialNo: 17,
    service: 'Both',
    tip: "I'm defining a workday as 8am to 5pm.",
    chkboxtype: '',
    renewal_question: 'How has your work-life balance changed?',
  },
  {
    _id: '0018',
    res_question: 'Which upgrades do you have in your home?',
    serialNo: 18,
    service: 'Switching Providers',
    tip: '',
    chkboxtype: 'Tap all that apply',
    renewal_question: 'Please indicate if you made any additional upgrades.',
  },
  {
    _id: '0019',
    res_question: 'Which upgrades will you have in your new home?',
    serialNo: 19,
    service: 'New Service',
    tip: '',
    chkboxtype: 'Tap all that apply',
    renewal_question: 'Please indicate if you made any additional upgrades.',
  },
  {
    _id: '0020',
    res_question: 'Which smart home connected devices do you have?',
    serialNo: 20,
    service: 'Switching Providers',
    tip:
      "I've noticed you could use a little help further reducing your energy bill.  In a few questions, I'll ask if you'd like for me to connect you with some of our trusted partners.",
    chkboxtype: 'Tap all that apply',
    renewal_question:
      'Please indicate if you purchased any additional smart home connected devices.',
  },
  {
    _id: '0021',
    res_question: 'Which smart home connected devices will your new home have?',
    serialNo: 21,
    service: 'New Service',
    tip:
      "I've noticed you could use a little help further reducing your energy bill.  In a few questions, I'll ask if you'd like for me to connect you with some of our trusted partners.",
    chkboxtype: 'Tap all that apply',
    renewal_question:
      'Please indicate if you purchased any additional smart home connected devices.',
  },
  {
    _id: '0022',
    res_question: 'How many light bulbs have you replaced with LED? ',
    serialNo: 22,
    service: 'Switching Providers',
    tip:
      "LEDs not only drastically reduce your light bills but good-quality LED bulbs can have a useful life of 25,000 hours or more (they can last more than three years if they're turned ON and run 24/7/365!)",
    chkboxtype: '',
    renewal_question:
      'Please indicate if you replaced any more lights bulbs with LED.',
  },
  {
    _id: '0023',
    res_question: 'How many light bulbs will be LED? ',
    serialNo: 23,
    service: 'New Service',
    tip:
      "LEDs not only drastically reduce your light bills but good-quality LED bulbs can have a useful life of 25,000 hours or more (they can last more than three years if they're turned on and run 24/7/365!)",
    chkboxtype: '',
    renewal_question:
      'Please indicate if you replaced any more lights bulbs with LED.',
  },
  {
    _id: '0024',
    res_question: 'How often do you typically replace your A/C filter? ',
    serialNo: 24,
    service: 'Both',
    tip:
      "You can save 5% to 15% on your heating and cooling costs by regularly cleaning or replacing the filters on your furnace or air conditioning unit.  Let's not forget about saving thousands on potential repair costs down the road with simple maintenance.",
    chkboxtype: '',
    renewal_question:
      'Did you replace the A/C filter any more frequently this past contract term? ',
  },

  {
    _id: '0026',
    res_question:
      "You're doing so good! What contract term length are you seeking?",
    serialNo: 26,
    service: 'Both',
    tip:
      "Best time to start or end an energy contract is during the 'off-peak' or 'shoulder' months of Nov - Mar.",
    chkboxtype: '',
    renewal_question:
      'Are you convinced to explore renewable energy options, even if it may cost a little more? ',
  },
  {
    _id: '0027',
    res_question: 'Are you currently a pre-paid electricity customer?',
    serialNo: 27,
    service: 'Both',
    tip:
      "If you can't locate exact number on your energy bill, it's okay to estimate.",
    chkboxtype: '',
  },
  {
    _id: '0028',
    res_question: 'Who is your current energy provider? ',
    serialNo: 28,
    service: 'Switching Providers',
    tip: '',
  },
  {
    _id: '0029',
    res_question:
      'Approximately how many months have you been a customer of [enter Energy Provider name]? ',
    serialNo: 29,
    service: 'Switching Providers',
    tip: '',
    hg_res_rules: [
      {
        res_question_id: '0028',
        parameter: 'current_provider',
      },
    ],
  },
  {
    _id: '0030',
    res_question:
      'Last question! What was your energy usage for the last 12 months?',
    serialNo: 30,
    service: 'Switching Providers',
    tip:
      'I will be using this data to project your energy costs. Please refer back to your recent electric bill or I can estimate your monthly usage based on ERCOT averages for your utility, which may or may not be an accurate reflection of your home’s actual historical usage. You can modify the usage data at any time in the screens that follow.',
  },
  {
    _id: '0031',
    res_question:
      'Please enter your 12 month usage history for each month listed below.',
    serialNo: 31,
    service: 'Switching Providers',
    tip:
      'I will be using this data to project your energy costs. Please refer back to your recent electric bill or I can estimate your monthly usage based on ERCOT averages for your utility, which may or may not be an accurate reflection of your home’s actual historical usage. You can modify the usage data at any time in the screens that follow.',
  },
  // {
  //   _id: '0030-Deleted',
  //   res_question:
  //     'What is the average price you paid last month per kWh (for all recurring charges, excluding government fees and taxes)?',
  //   serialNo: '30-deleted',
  //   service: 'Switching Providers',
  //   tip:
  //     'Grab your most recent energy bill and look for where it specifically states,"The average price you paid for electric service this month (per kWh): 0.XXX". FYI, you don’t have to do any math. The average price will already include all recurring charges, like Base Charge, Energy Charge, Delivery Charges, Minimum Usage Fees, etc and exclude things like PUC Assessment, Gross Receipts Tax Reimbursement, Sales Tax etc.  ',
  // },
];
